import AppKiosk from '@/components/App/AppKiosk.vue'

const Kiosk = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-kiosk', AppKiosk)
    Vue.prototype.$kiosk = {
      add(params) {
        Kiosk.EventBus.$emit('add', params)
      },
      edit(params) {
        Kiosk.EventBus.$emit('edit', params)
      }
    }
  }
}

export default Kiosk